export default __webpack_public_path__ + "static/media/texture.58034b05.png";